<template>
  <div>
    <div class="TopContainer">
      <div class="img cursor-pointer back" @click="$router.push('/list')">
       <!-- <img class="logo" src="/static/img/logo-home.png"/> -->
        <i class="el-icon-arrow-left" style="margin-top: 2px;"></i>
        <span>返回问卷列表</span>
      </div>
      <!-- <ul class="TopHeader">
        <li v-for="item in titleList" :key="item.title" @click="toUrl(item.url)" style="cursor: default">{{ item.title }}</li>
      </ul> -->
    </div>
    <el-drawer
      title="预览问卷"
      direction="rtl"
      size="90%"
      :visible.sync="dialogVisible"
      :before-close="handleClose">
      <preview/>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-drawer>
  </div>
</template>

<script>
import preview from '@/views/qms/components/preview';

export default {
  name: 'share',
  components: {
    preview
  },
  data() {
    return {
      dialogVisible: false,
      titleList: [
        {
          title: '我的问卷',
          url: '/list'
        },
        /*{
          title: '问卷类型'
        }*/
      ],

    }
  }, methods: {
    test() {
    },
    handleClose(done) {
      this.$confirm('确认关闭？').then(_ => {
        done();
      }).catch(_ => {
      });
    },
    toUrl(url) {
      this.$router.push(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.img {
  height: 60px;
  width: 150px;
  display: flex;
  align-items: center;
}
.back{
  display:flex;
  align-items:center;
  gap:3px;
}

.logo {
  width: 60px;
}

.footer {
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #333;
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #fff inset;
}

.login-container .el-input input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
}

/*@media screen and (min-width: 700px) {
  .img{
    position: absolute;
    left:20px;
  }
}*/
</style>



// WEBPACK FOOTER //
// src/views/layout/share.vue